import { LifeBuoy } from 'lucide-react';

import { useBanner } from '@/lib/banner';

import { useSessaoEmMemoria } from './memoria';

/**
 * A SESSÃO DE SUPORTE DA PLATAFORMA (0033, decisão 26) avisa o que é: quem
 * está olhando é o suporte, nada muda por aqui, e cada tela aberta fica na
 * trilha desta empresa. É uma condição que vale para a tela inteira e dura a
 * sessão: o banner da p.33.
 *
 * INFORMATIVO, e não crítico. O crítico da p.33 é falha (o vermelho do "Sem
 * conexão") e não fecha; a sessão de suporte não é falha, e um crítico do
 * tamanho da sessão tomaria o lugar de todo outro banner — no empate, até o
 * da rede caída. Quem leu fecha no ✕, e a dispensa vale até o navegador
 * fechar.
 *
 * R06 (p.67): "Suporte é azul, de informação. Vira âmbar só se o atendimento
 * afetar o uso do sistema." A sessão de suporte é só leitura PARA QUEM ENTROU
 * COMO SUPORTE, que sabe disso; o uso das pessoas da empresa não muda. Fica
 * azul, com o ícone que a p.67 desenha (`life-buoy`). A ação "Abrir chamado"
 * da p.67 não entra: o sistema não tem chamado, e botão que não faz nada não
 * entra.
 */
export function useBannerDeSuporte(): void {
  const sessao = useSessaoEmMemoria();
  useBanner(
    sessao?.suporte === true
      ? {
          id: `suporte:${sessao.usuarioId}`,
          gravidade: 'informativo',
          icone: LifeBuoy,
          texto:
            'Acesso de suporte da plataforma. Só leitura: nenhuma mudança é gravada por esta sessão. Cada tela aberta fica na trilha desta empresa. Para sair, use Sair do sistema.',
          rotuloDeFechar: 'Fechar o aviso de suporte',
        }
      : null,
  );
}
